import { Container, Stack, Typography } from "@mui/material";
import GlobalHeader from "../../../components/GlobalHeader";
import SnackAlert from "../../../components/SnackAlert";
import useSnack from "../../../hooks/useSnack";
import ListaEventos from "../../../components/ListaEventos";

// Los eventos de un perfil individual (solista, grupo), donde el perfil ES
// el artista. Los sellos, managers y labels no
// llegan por acá: sus eventos cuelgan de cada ficha de su roster.
export default function ViewEventos() {
  const { msgSB, openSB, showSnack, typeSB } = useSnack();

  return (
    <>
      <GlobalHeader />
      <Container>
        <Stack mb={1}>
          <Typography variant="h4" color="primary.main" fontWeight="900">
            MIS EVENTOS
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Shows, giras y festivales que quieras difundir. Se envían a los
            difusores igual que una canción.
          </Typography>
        </Stack>

        <ListaEventos showSnack={showSnack} titulo="Próximos y pasados" />
      </Container>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}
